import { IconDefinition } from '@ant-design/icons-angular';
import {
  AlertOutline,
  AppstoreOutline,
  ArrowDownOutline,
  ArrowLeftOutline,
  ArrowRightOutline,
  ArrowUpOutline,
  AuditOutline,
  BankOutline,
  BarChartOutline,
  BellOutline,
  BoldOutline,
  CalculatorOutline,
  CalendarOutline,
  CarOutline,
  CheckCircleFill,
  CheckCircleOutline,
  CheckOutline,
  ClearOutline,
  ClockCircleOutline,
  CloseCircleFill,
  CloseCircleOutline,
  CloseOutline,
  CloudUploadOutline,
  CodeOutline,
  CompassOutline,
  CopyOutline,
  CreditCardOutline,
  DeleteOutline,
  DesktopOutline,
  DisconnectOutline,
  DollarOutline,
  DoubleRightOutline,
  DownOutline,
  DownloadOutline,
  DragOutline,
  EditOutline,
  EllipsisOutline,
  EnvironmentOutline,
  ExceptionOutline,
  ExclamationCircleFill,
  ExclamationCircleOutline,
  ExportOutline,
  EyeInvisibleOutline,
  EyeOutline,
  FileAddOutline,
  FileDoneOutline,
  FileExcelOutline,
  FileOutline,
  FilePdfOutline,
  FileProtectOutline,
  FileSearchOutline,
  FileTextOutline,
  FilterFill,
  FilterOutline,
  FireOutline,
  FolderOpenOutline,
  GlobalOutline,
  HeartOutline,
  HolderOutline,
  HomeOutline,
  HourglassOutline,
  IdcardOutline,
  InboxOutline,
  InfoCircleOutline,
  InfoOutline,
  ItalicOutline,
  LayoutOutline,
  LeftOutline,
  LikeOutline,
  LineOutline,
  LinkOutline,
  LoadingOutline,
  LockOutline,
  LoginOutline,
  LogoutOutline,
  MenuFoldOutline,
  MenuOutline,
  MenuUnfoldOutline,
  MessageOutline,
  MinusCircleOutline,
  MinusOutline,
  MobileOutline,
  MoonOutline,
  MoreOutline,
  NotificationOutline,
  NumberOutline,
  OrderedListOutline,
  PaperClipOutline,
  PictureOutline,
  PieChartOutline,
  PlayCircleOutline,
  PlusCircleOutline,
  PlusOutline,
  ProfileOutline,
  QuestionCircleOutline,
  RedoOutline,
  ReloadOutline,
  RetweetOutline,
  RightOutline,
  RollbackOutline,
  SafetyCertificateOutline,
  SafetyOutline,
  SaveOutline,
  SearchOutline,
  SendOutline,
  SettingOutline,
  ShoppingCartOutline,
  ShoppingOutline,
  SlidersOutline,
  SolutionOutline,
  StarFill,
  StopOutline,
  StrikethroughOutline,
  SunOutline,
  SyncOutline,
  TeamOutline,
  ThunderboltOutline,
  ToolOutline,
  TransactionOutline,
  UndoOutline,
  UnorderedListOutline,
  UpOutline,
  UploadOutline,
  UserAddOutline,
  UserOutline,
  UserSwitchOutline,
  WalletOutline,
  WarningFill,
  WarningOutline,
  WarningTwoTone,
} from '@ant-design/icons-angular/icons';

/**
 * Every icon the portals name in a template or menu config, registered up front so nz-icon never fetches its SVG at
 * runtime. Those fetches fail on flaky networks and captive portals (an HTML page comes back), which is what Sentry
 * reports as "<svg> tag not found" and "icon does not exist". An icon missing here still loads the old way.
 */
export const IcIcons: IconDefinition[] = [
  AlertOutline,
  AppstoreOutline,
  ArrowDownOutline,
  ArrowLeftOutline,
  ArrowRightOutline,
  ArrowUpOutline,
  AuditOutline,
  BankOutline,
  BarChartOutline,
  BellOutline,
  BoldOutline,
  CalculatorOutline,
  CalendarOutline,
  CarOutline,
  CheckCircleFill,
  CheckCircleOutline,
  CheckOutline,
  ClearOutline,
  ClockCircleOutline,
  CloseCircleFill,
  CloseCircleOutline,
  CloseOutline,
  CloudUploadOutline,
  CodeOutline,
  CompassOutline,
  CopyOutline,
  CreditCardOutline,
  DeleteOutline,
  DesktopOutline,
  DisconnectOutline,
  DollarOutline,
  DoubleRightOutline,
  DownOutline,
  DownloadOutline,
  DragOutline,
  EditOutline,
  EllipsisOutline,
  EnvironmentOutline,
  ExceptionOutline,
  ExclamationCircleFill,
  ExclamationCircleOutline,
  ExportOutline,
  EyeInvisibleOutline,
  EyeOutline,
  FileAddOutline,
  FileDoneOutline,
  FileExcelOutline,
  FileOutline,
  FilePdfOutline,
  FileProtectOutline,
  FileSearchOutline,
  FileTextOutline,
  FilterFill,
  FilterOutline,
  FireOutline,
  FolderOpenOutline,
  GlobalOutline,
  HeartOutline,
  HolderOutline,
  HomeOutline,
  HourglassOutline,
  IdcardOutline,
  InboxOutline,
  InfoCircleOutline,
  InfoOutline,
  ItalicOutline,
  LayoutOutline,
  LeftOutline,
  LikeOutline,
  LineOutline,
  LinkOutline,
  LoadingOutline,
  LockOutline,
  LoginOutline,
  LogoutOutline,
  MenuFoldOutline,
  MenuOutline,
  MenuUnfoldOutline,
  MessageOutline,
  MinusCircleOutline,
  MinusOutline,
  MobileOutline,
  MoonOutline,
  MoreOutline,
  NotificationOutline,
  NumberOutline,
  OrderedListOutline,
  PaperClipOutline,
  PictureOutline,
  PieChartOutline,
  PlayCircleOutline,
  PlusCircleOutline,
  PlusOutline,
  ProfileOutline,
  QuestionCircleOutline,
  RedoOutline,
  ReloadOutline,
  RetweetOutline,
  RightOutline,
  RollbackOutline,
  SafetyCertificateOutline,
  SafetyOutline,
  SaveOutline,
  SearchOutline,
  SendOutline,
  SettingOutline,
  ShoppingCartOutline,
  ShoppingOutline,
  SlidersOutline,
  SolutionOutline,
  StarFill,
  StopOutline,
  StrikethroughOutline,
  SunOutline,
  SyncOutline,
  TeamOutline,
  ThunderboltOutline,
  ToolOutline,
  TransactionOutline,
  UndoOutline,
  UnorderedListOutline,
  UpOutline,
  UploadOutline,
  UserAddOutline,
  UserOutline,
  UserSwitchOutline,
  WalletOutline,
  WarningFill,
  WarningOutline,
  WarningTwoTone,
];
